import { render, staticRenderFns } from "./BlackPaymentAI.vue?vue&type=template&id=1cd29e47&"
import script from "./BlackPaymentAI.vue?vue&type=script&lang=js&"
export * from "./BlackPaymentAI.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports